import urlWithParams from "@utils/urlWithParams";

export const api = {
  // BASE
  BASE: urlWithParams(""), // AUTHENTICATION
  REFRESH: urlWithParams(window._env_.SERVER_IDENTITY + "/User/Refresh"),
  // USER
  USER: urlWithParams(window._env_.SERVER_IDENTITY + "/User/Profile"),
  PROFILE_IMAGE: (id: string, hash: string) =>
    id
      ? urlWithParams(window._env_.SERVER_MEDIA + "/GroupMedia/" + id, { hash })
      : `${require("@assets/avatars/User.png").default}`,
  // POSITION_WITH_GROUP
  POSITIONS_WITH_GROUP: urlWithParams(
    window._env_.SERVER_CREWS + "/CrewType/PositionsWithFleetGroups"
  ),
  // CATEGORY_DOCUMENT
  DOCUMENT_CATEGORIES: urlWithParams(
    window._env_.SERVER_CREWS + "/DocumentTemplate/Categories"
  ),
  // LIST_DOCUMENTS | CREATE_DOCUMENT | UPDATE_DOCUMENTS | LIST_DOCUMENTS_ACTIVE
  DOCUMENT_TEMPLATE: urlWithParams(
    window._env_.SERVER_CREWS + "/DocumentTemplate"
  ),
  // ASSINED_DOCUMENT_TEMPLATE
  ASSINED_DOCUMENT_TEMPLATE: urlWithParams(
    window._env_.SERVER_CREWS + "/Crewtype/assignedDocumentTemplates"
  ),
  // ASSINED_DOCUMENT_TEMPLATE_POST
  ASSINED_DOCUMENT_TEMPLATE_POST: urlWithParams(
    window._env_.SERVER_CREWS + "/Crewtype/assignDocuments"
  ),
  // LIST_CABINS
  CABIN_TEMPLATE: urlWithParams(
    window._env_.SERVER_BFF_PANEL + "/Crew/CabinList"
  ),
  // LIST_COCKPITS
  COCKPIT_TEMPLATE: urlWithParams(
    window._env_.SERVER_BFF_PANEL + "/Crew/CockpitList"
  ),
  // COCKPIT_CHECK
  COCKPIT_CHECK_CREW: urlWithParams(
    window._env_.SERVER_BFF_PANEL + "/Crew/CheckIsCockpitCrew"
  ),
  // COCKPIT_CREW | CREATE_CREW_COCKPIT | COCKPIT_JOB_List | DEACTIVE_CREW | UPADATE_JOB_CREW | GET_JOB_CREW
  COCKPIT_CREW: urlWithParams(window._env_.SERVER_CREWS + "/Crew/Cockpit"),
  // CABIN_CREW | CREATE_CREW_COCKPIT | CABIN_JOB_List | DEACTIVE_CREW | UPADATE_JOB_CREW | GET_JOB_CREW
  CABIN_CREW: urlWithParams(window._env_.SERVER_CREWS + "/Crew/cabin"),
  // LIST_COCKPITS
  CABIN_CHECK_CREW: urlWithParams(
    window._env_.SERVER_BFF_PANEL + "/Crew/CheckIsCabinCrew"
  ),
  // LIST_CAREERS
  CAREERS: urlWithParams(window._env_.SERVER_CREWS + "/Crew/Careers"),
  // LIST_CREW_TYPE
  LIST_CREW_TYPE: urlWithParams(window._env_.SERVER_CREWS + "/Crewtype"),
  // MEDIA_UPLOAD
  MEDIA_UPLOAD: urlWithParams(window._env_.SERVER_MEDIA + "/GroupMedia"),
  // MEDIA_UPLOAD
  COMMON_AIRCRAFT: urlWithParams(window._env_.SERVER_CREWS + "/Aircraft"),
  // MEDIA_UPLOAD |
  COMMON_INFO_PERSONAL: urlWithParams(window._env_.SERVER_BFF_PANEL + "/Crew"),
  // SIGNIFICANT_NOTE
  SIGNIFICANT_NOTE: urlWithParams(window._env_.SERVER_CREWS + "/Crew"),

  //Version
  GET_VERSION_CHANGE_LOG: () =>
    urlWithParams(window._env_.SERVER_PLATFORM + `/Version/ChangeLog`),

  GET_VERSION_INFO: () =>
    urlWithParams(window._env_.SERVER_PLATFORM + `/Version`),
};
